import Rollbar from 'rollbar';
import {
  APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  Injectable,
  InjectionToken,
  Injector,
  NgModule,
  NO_ERRORS_SCHEMA
} from '@angular/core';

import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { FormSharedModule } from './shared/form-shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { PlantillaModule } from './shared/plantilla/plantilla.module';
import { AutenticacionModule } from './shared/autenticacion/autenticacion.module';
import { DashboardModule } from './shared/dashboard/dashboard.module';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { RequestsInterceptor } from './_interceptor/requests.interceptor';
import { AppSettings } from '../proyect.conf';
import { ConfirmationService } from 'primeng/api';
import { BrowserModule } from '@angular/platform-browser';
import { NavService } from './_services/_nav.service';
import { BreadcrumbModule } from './shared/breadcrumb/breadcrumb.module';
import { BreadcrumbService } from './shared/breadcrumb/breadcrumb.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
// SocketIO
import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { ErroresModule } from './shared/error/errores.module';
import { AuthGuard } from './_guards/auth.guard';
import { SocialAuthService,  } from '@abacritt/angularx-social-login';
import { obtenerRxStompConfig } from './my-rx-stomp.config';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { UtilitiesService } from './utils/utilities.service';
import { AppSettingService } from './_services/app-setting.service';
import Sortable from 'sortablejs';
import { ConfigService } from './app-config';
import { SocketConexion } from './_services/socket-conexion.service';
import { QuillModule } from 'ngx-quill';
import { ClasificadorAutoPasivo } from './utils/utilidades';
import { ProductoService } from './_services/producto.service';
import { ConstanteService } from './_services/constante.service';
// Lista Solicitudes Socket
import { ListasolicitudessocketService } from './_services/listasolicitudessocket.service';
// ----------------------------
import { CalcularEndeudamientoInternoService } from './_services/calcular-endeudamiento-interno.service';
import { PysModule } from './PYS/pys.module';
import {RollbarErrorHandler, rollbarFactory} from './_services/rollbar-error-handler.service';
import {RollbarService} from './_services/rollbar.service';
import { ContenedoresService } from './_services/contenedores.service';
// ----------------------------
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { provideLottieOptions } from 'ngx-lottie';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from '@abacritt/angularx-social-login';
import {NgxSpinnerModule} from 'ngx-spinner';
import {ToastModule} from 'primeng/toast';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import type { FaceTecSDK as FaceTecSDKType } from "../assets/facetec/core-sdk/FaceTecSDK.js/FaceTecSDK";
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';

const appInitializerFn = ( configService: ConfigService ) => {
  return () => {
    return configService.setConfig();
  };
};

/**
 * Asignar lenguaje.
 * @param {HttpClient} http
 * @returns {TranslateHttpLoader}
 */

export function createTranslateLoader( http: HttpClient ) {
  return new TranslateHttpLoader( http, './assets/i18n/', '.json' );
}

/**
 * Obtener token.
 * @returns {string}
 */
export function tokenGetter() {
  return localStorage.getItem( 'token' );
}

/**
 * Configuración del servicio de autenticación por google.
 */
/* export function provideConfig() {
  const config = new AuthServiceConfig( [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider( AppSettings.idGoogleCliente )
    }
  ] );
  return config;
} */

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => tokenGetter(),
    authScheme: '',
    whitelistedDomains: [ AppSettings.rutMilitarizada ],
    blacklistedRoutes: [ new RegExp( AppSettings.rutDesmilitarizada ) ]
  };
}
@NgModule( { declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
            },
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        MessagesModule,
        MessageModule,
        NgxSpinnerModule,
        ToastModule,
        QuillModule.forRoot(),
        FormSharedModule.forRoot(),
        SharedModule.forRoot(),
        BreadcrumbModule.forRoot(),
        // Sortable,
        ErroresModule,
        PlantillaModule,
        AutenticacionModule,
        DashboardModule,
        AppRoutingModule,
        SocialLoginModule,
        NgIdleKeepaliveModule.forRoot(),
        SocketIoModule
  ],
  providers: [
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFn,
            multi: true,
            deps: [ConfigService]
        },
        ConfirmationService,
        SocketConexion,
        NavService,
        BreadcrumbService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestsInterceptor,
            multi: true,
        },
        /* {
          provide: SocialAuthService,
          useFactory: provideConfig
        }, */
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                  {
                    id: GoogleLoginProvider.PROVIDER_ID,
                    provider: new GoogleLoginProvider(
                      AppSettings.idGoogleCliente
                    )
                  }
                ],
                onError: (err) => {
                    console.error('***** Error google: ' + err);
                }
            } as SocialAuthServiceConfig,
        },
        { provide: ErrorHandler, useClass: RollbarErrorHandler },
        { provide: RollbarService, useFactory: rollbarFactory },
        {
            provide: InjectableRxStompConfig,
            useFactory: obtenerRxStompConfig
        },
        {
            provide: RxStompService,
            useFactory: rxStompServiceFactory,
            deps: [InjectableRxStompConfig]
        },
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
        UtilitiesService,
        AppSettingService,
        ClasificadorAutoPasivo,
        ProductoService,
        ConstanteService,
        ListasolicitudessocketService,
        CalcularEndeudamientoInternoService,
        ContenedoresService,
        provideHttpClient(withInterceptorsFromDi()),
    ] } )
export class AppModule {
}

declare global {
  const FaceTecSDK: typeof FaceTecSDKType;
}
